import { Map, List } from 'immutable'
import { createDraft } from './draft'

export const EMPTY_MAP = Map()
export const EMPTY_LIST = List()
export const EMPTY_OBJECT = {}

/**
 * selects the community authentication data
 * @param {Object} state - redux state.community
 */
export function selectAuth (state) {
  return state.get('auth', EMPTY_MAP)
}

/**
 * is user forbidden from global access to community
 * @param {Object} state - redux state.community
 */
export function selectAuthForbidden (state) {
  const auth = selectAuth(state)
  return auth.get('forbidden') === true
}

/**
 * is user allowed global access to community
 * @param {Object} state - redux state.community
 */
export function selectAuthAllowed (state) {
  const auth = selectAuth(state)
  return auth.get('forbidden') === false
}

/**
 * are we currently creating a session ?
 * @param {Object} state - redux state.community
 */
export function selectAuthProcessing (state) {
  const auth = selectAuth(state)
  return auth.get('processing') === true
}

/**
 * select community feed data
 * @param {Object} state - redux state.community
 * @param {String} id - the feed id
 */
export function selectFeed (state, id) {
  const feeds = state.get('feeds', Map())
  let feed = Map()
  if (feeds && feeds.size > 0) {
    feeds.keySeq().forEach((key) => {
      if (feeds.getIn([key, 'feed']) === id) {
        feed = feeds.get(key)
      }
    })
  }
  return feed
}

/**
 * finds a draft in the redux community store
 * @param {Object} state - redux community state
 * @param {String} draftId - the draft id
 */
export function selectDraft (state, draftId, parent, type) {
  return state.getIn(['drafts', draftId], createDraft(parent, type))
}

/**
 * gets an activity from the store
 * @param {Object} state - redux community state
 * @param {String} activityId - an immutable activity
 */
export function selectActivity (state, activityId) { // activities are not currently immutable
  return state.getIn(['activities', activityId], EMPTY_OBJECT)
}

/**
 * finds an activities photo attachments
 * @param {import('immutable').Map} activity - an immutable activity
 */
export function selectActivityPhotos (activity = EMPTY_MAP) {
  return activity.getIn(['attachments', 'images']) || EMPTY_LIST
}

/**
 * finds an activities open graphs
 * @param {import('immutable').Map} activity - an immutable activity
 */
export function selectActivityOGs (activity = EMPTY_MAP) {
  return activity.getIn(['attachments', 'og']) || EMPTY_LIST
}

/**
 * finds an activities open graphs that are renderable
 * @param {import('immutable').Map} activity - an immutable activity
 */
export function selectRenderableActivityOGs (activity = EMPTY_MAP) {
  const ogs = selectActivityOGs(activity)
  return ogs.filter(og => og.get('render'))
}
